"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PathSymbol = Symbol("MustacheDataPath");
function createPropertyPathArray({ target, propertyName, }) {
    return [...(target[PathSymbol] || []), propertyName];
}
function proxyMustacheData(data, options) {
    if (typeof data !== "object") {
        return data;
    }
    return new Proxy(data, {
        get(target, propertyName) {
            let value = target[propertyName];
            if (value === undefined && !(propertyName in target)) {
                const pathSegments = createPropertyPathArray({ target, propertyName });
                if (options === null || options === void 0 ? void 0 : options.handleError) {
                    options.handleError(pathSegments);
                    return value;
                }
                throw Error(`Missing Mustache data property: ${pathSegments.join(" > ")}`);
            }
            if (value && typeof value === "object") {
                value[PathSymbol] = createPropertyPathArray({ target, propertyName });
                return proxyMustacheData(value, options);
            }
            return value;
        },
    });
}
exports.default = proxyMustacheData;
